(function () {
  'use strict';

  angular
    .module('uwAgenda.website.privacypolicy')
    .directive('privacyPolicyFileChange', PrivacyPolicyFileChangeDirectiveFn);

  function PrivacyPolicyFileChangeDirectiveFn() {
    return {
      restrict: 'A',
      link: function (scope, element, attrs) {
        element.on('change', function ($event) {
          // Bridge native file input events into AngularJS digest safely.
          scope.$applyAsync(function () {
            scope.$eval(attrs.privacyPolicyFileChange, { $event: $event });
          });
        });

        scope.$on('$destroy', function () {
          element.off('change');
        });
      }
    };
  }
})();

